/*
  Tiny shared registry so the global breadcrumb topbar can show a friendly
  name for a dynamic route segment (e.g. a campaign id) instead of the raw id.

  The topbar (XpnsrTopbar) only has the URL, so pages that DO know the entity's
  name — CampaignDetail, Streams, etc. — register it here via
  setBreadcrumbName(id, name). The topbar subscribes and re-renders, falling
  back to the truncated id until a name is known. Module-level so it survives
  route changes within a session; intentionally not persisted.
*/

const names = new Map();
const listeners = new Set();
let version = 0;

export function setBreadcrumbName(id, name) {
  if (!id || !name) return;
  if (names.get(id) === name) return;
  names.set(id, name);
  version += 1;
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* a broken listener must not break the others */
    }
  });
}

export function getBreadcrumbName(id) {
  return id ? names.get(id) : undefined;
}

export function subscribeBreadcrumbNames(fn) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function breadcrumbNamesVersion() {
  return version;
}
